var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!!_vm.data)?_c('article',{staticClass:"col-33"},[_c('a',{staticClass:"clipping-item",attrs:{"href":_vm.server+_vm.data.archivo,"download":"","target":"_blank"}},[_c('div',[_c('img',{attrs:{"src":_vm.server+_vm.data.miniatura,"alt":""}})]),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.data.titulo)}})])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-449924dd","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/pressroom-el.vue
// module id = null
// module chunks = 